import React, { Component } from 'react'
import RoleControlled from '../../_common/RoleControlled'
import { deleteMsg } from '../../../const'

class PublicFacilityItem extends Component {
  constructor (props) {
    super(props)

    this.state = {
      edit: false,
      defaultName: this.props.facility.name,
      defaultBody: this.props.facility.body,
      name: this.props.facility.name,
      body: this.props.facility.body
    }
  }

  shouldComponentUpdate (nextProps, nextState) {
    const { facility } = this.props
    const { edit, name, body } = this.state
    if (
      facility.name !== nextProps.facility.name ||
      facility.body !== nextProps.facility.body ||
      edit !== nextState.edit ||
      name !== nextState.name ||
      body !== nextState.body
    ) {
      return true
    } else {
      return false
    }
  }

  _handleEditClick () {
    this.setState({ edit: true })
  }
  _handleDeleteClick () {
    console.log('delete facility id: ', this.props.facility.id)
    const res = window.confirm(deleteMsg)
    if (res) {
      this.props.deleteData(this.props.facility.id)
    }
  }
  _handleCancelClick () {
    this.setState({
      edit: false,
      name: this.state.defaultName,
      body: this.state.defaultBody
    })
  }
  _handleSaveClick () {
    console.log('saving data...')
    const { name, body } = this.state
    const data = {
      facility_id: this.props.facility.id,
      name,
      body
    }
    this.props.saveData(data)
    this.setState({ edit: false })
  }

  _handleUpdateContent (key, e) {
    this.setState({ [key]: e.target.value })
  }

  _renderFacilityName () {
    if (this.state.edit) {
      return <textarea rows="1" type="text" value={this.state.name} onChange={this._handleUpdateContent.bind(this, 'name')}></textarea>
    }
    return (
      <div className="facility_value value">{this.state.name}</div>
    )
  }
  _renderFacilityBody () {
    if (this.state.edit) {
      return <textarea rows="1" type="text" value={this.state.body} onChange={this._handleUpdateContent.bind(this, 'body')}></textarea>
    }
    return (
      <div className="facility_value value">{this.state.body}</div>
    )
  }

  _renderBtns () {
    if (this.state.edit) {
      return [
        <button key="cancel" className="btn reverse_red" onClick={this._handleCancelClick.bind(this)}>キャンセル</button>,
        <button key="save" className="btn reverse_primary" onClick={this._handleSaveClick.bind(this)}>保存</button>
      ]
    }
    return [
      <button key="delete" className="btn red" onClick={this._handleDeleteClick.bind(this)}>削除</button>,
      <button key="edit" className="btn reverse_primary" onClick={this._handleEditClick.bind(this)}>編集</button>
    ]
  }

  render () {
    return (
      <article className="facility">
        <div className="facility_inner admin_inner flex column">
          <div className="contents flex top_label">
            <div className="facility_label label">公共施設名</div>
            { this._renderFacilityName()}
          </div>
          <div className="contents flex bottom_label">
            <div className="facility_label label">電話番号</div>
            { this._renderFacilityBody()}
          </div>
        </div>
        <RoleControlled role={this.props.role} acceptedRoles={[0, 1]}>
          <div className="btn_group flex">
            { this._renderBtns() }
          </div>
        </RoleControlled>
      </article>
    )
  }
}

export default PublicFacilityItem



// WEBPACK FOOTER //
// ./src/components/Properties/PublicFacilities/PublicFacilityItem.js